import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import { styled } from "@mui/material/styles";
import OutlinedInput, { OutlinedInputProps } from "@mui/material/OutlinedInput";
import tickIcon from "../../assets/tickicon.svg";

// Define the props type for RoleInput
interface RoleInputProps extends OutlinedInputProps {
  selected: boolean;
  onClick: () => void;
}

// Type for styled component props
interface CustomInputFieldProps extends OutlinedInputProps {
  selected: boolean;
}

const CustomInputField = styled(OutlinedInput)<CustomInputFieldProps>`
  height: 80px;
  color: white;
  text-align: left !important;
  padding: 0 16px;

  border-color: #365f91;
  border: 1.4px solid transparent;
  background: ${({ selected }) =>
    !selected
      ? `linear-gradient(black, black) padding-box, linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box`
      : "#fb5012"};
  border-image-slice: 1;
  border-radius: 25px;
  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: transparent;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
  }
`;

const RoleInput: React.FC<RoleInputProps> = ({
  type,
  onChange,
  placeholder,
  selected,
  onClick,
  ...props
}) => {
  return (
    <CustomInputField
      type={type}
      onChange={onChange}
      placeholder={placeholder}
      selected={selected}
      fullWidth
      inputProps={{
        style: {
          textAlign: "left",
          paddingLeft: "16px",
        },
      }}
      endAdornment={
        selected && (
          <InputAdornment position="end">
            <img src={tickIcon} alt="Tick Icon" />
          </InputAdornment>
        )
      }
      onClick={onClick}
      {...props}
    />
  );
};

export default RoleInput;
